import { extendTheme } from "@mui/material";
import DirectionsRunIcon from "@mui/icons-material/DirectionsRun";
import HealingSharpIcon from "@mui/icons-material/HealingSharp";
import CardMembershipIcon from "@mui/icons-material/CardMembership";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import MilitaryTechIcon from "@mui/icons-material/MilitaryTech";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import RouteIcon from "@mui/icons-material/Route";

export const NAVIGATION = [
  {
    kind: "header",
    title: "Barra de navegación",
  },
  {
    segment: "dashboard/users",
    title: "Usuarios",
    icon: <DirectionsRunIcon />,
  },

  {
    segment: "dashboard/specialist",
    title: "Especialistas",
    icon: <HealingSharpIcon />,
  },
  {
    segment: "dashboard/admins",
    title: "Administradores",
    icon: <AdminPanelSettingsIcon />,
  },
  {
    segment: "dashboard/memberships",
    title: "Membresías",
    icon: <CardMembershipIcon />,
  },
  {
    segment: "dashboard/roles",
    title: "Roles ",
    icon: <VerifiedUserIcon />,
  },
  {
    kind: "divider",
  },
  {
    kind: "header",
    title: "Sitio web",
  },
  {
    segment: "dashboard/offerts",
    title: "Ofertas",
    icon: <LocalOfferIcon />,
  },
  {
    segment: "dashboard/badges",
    title: "Logros",
    icon: <MilitaryTechIcon />,
  },
  {
    segment: "dashboard/routes",
    title: "Rutas",
    icon: <RouteIcon />,
  },
];
export const demoTheme = extendTheme({
  colorSchemes: { dark: true },

  components: {
    MuiListItemButton: {
      styleOverrides: {
        root: {
          "&.Mui-selected": {
            backgroundColor: "rgba(212, 216, 216, 0.32)",
            "& .MuiListItemIcon-root, & .MuiSvgIcon-root": {
              color: "#e7ef7d !important",
            },
          },
        },
      },
    },
  },
});
